import {
  ActiveUserDto,
  BoroughPreferenceDto, HouseholdMemberDto,
  IncomeOptionTypeDto,
  incomeOptionTypes,
  MandatoryFlowUserDto,
  PreferencesDto,
  RoomPreferenceDto,
  SignupFlowUserDto
} from "homey-housing-lottery-app-dto";
import {User} from "../services/user.service";

export type SignupFlowUser = SignupFlowUserDto;
export type MandatoryFlowUser = MandatoryFlowUserDto;
export type ActiveUser = ActiveUserDto;
export type IncomeOption = IncomeOptionTypeDto;
export const incomeOptions = incomeOptionTypes;
export type Preferences = PreferencesDto;
export type BoroughPreference = BoroughPreferenceDto;
export type RoomPreference = RoomPreferenceDto;
export type HouseholdMember = HouseholdMemberDto;

export const getLowerIncomeBound = (incomeOption: IncomeOption): number => {
  switch (incomeOption) {
    case "20000-50000":
      return 20000;
    case "50000-100000":
      return 50000;
    case "100000-150000":
      return 100000;
    case "150000-240000":
      return 150000;
  }
}

export const getUpperIncomeBound = (incomeOption: IncomeOption): number => {
  switch (incomeOption) {
    case "20000-50000":
      return 50000;
    case "50000-100000":
      return 100000;
    case "100000-150000":
      return 150000;
    case "150000-240000":
      return 240000;
  }
}

export type AssetsFormData = Partial<{
  checkingSavingsAccount: number,
  savingsAccount: number,
  retirementAccount: number,
  brokerageInvestmentsAccount: number,
  investmentAccount: number,
  realEstate: number,
}>

export const hasProblemWithHouseholdMembers = (householdMembers: HouseholdMember[]) => {
  return householdMembers.every((member) => member.student) && householdMembers.length > 0;
}

export const isPostSignupFlowUser = (user: User | undefined): user is MandatoryFlowUser | ActiveUser => {
  return user !== undefined && (user.status === 'mandatory-flow' || user.status === 'active');
}

export const isDeferredUser = (user?: User): boolean => {
  if (!user || user.status === 'unauthorized' || user.status === 'signup-flow') {
    return false;
  }

  return user.paymentInfo?.type === 'deferred';
};

const hasCompletedMandatoryFlowForms = (user: MandatoryFlowUser): boolean => user.isProfileComplete;

export const isDeferredMandatoryUserAwaitingPayment = (user: MandatoryFlowUser): boolean => {
  return user.paymentInfo.type === 'deferred'
    && user.paymentStatus === 'not-paid'
    && hasCompletedMandatoryFlowForms(user);
};

export type PostSignupUser = ActiveUser | MandatoryFlowUser;
